import i18n from "@/i18n";

const PATTERN_TO_KEY: Record<string, string> = {
  "network error": "error.network",
  "failed to fetch": "error.failedToFetch",
  "session not found": "error.sessionNotFound",
  "failed to send": "error.failedToSend",
  "rate limit": "error.rateLimit",
  "unauthorized": "error.unauthorized",
  "token": "error.token",
  "timeout": "error.timeout",
  "qr": "error.qr",
  "phone": "error.phone",
  "invalid format": "error.invalidFormat",
};

export function getFriendlyErrorMessage(error: any): string {
  if (!error) return "";

  // Extract error string
  let errorStr = "";
  if (typeof error === "string") {
    errorStr = error;
  } else if (error instanceof Error) {
    errorStr = error.message;
  } else if (error && typeof error === "object") {
    errorStr = error.message || error.error || error.response || JSON.stringify(error);
  }

  const cleanError = errorStr.toLowerCase();

  // Find matching pattern
  for (const [pattern, key] of Object.entries(PATTERN_TO_KEY)) {
    if (cleanError.includes(pattern)) {
      return i18n.t(key, { ns: "common" });
    }
  }

  // Fallback friendly message
  return i18n.t("error.unexpected", { ns: "common" });
}
